// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电气测量",
      "tec": "韩希昌",
      "week": "3-9周",
      "add": "214国教"
    },
    {
      "sub": "模拟电子技术",
      "tec": "张玉梅",
      "week": "3-9,13-18周",
      "add": "319国教"
    },
    [
      {
        "sub": "交际口语3",
        "tec": "外教6",
        "week": "3-9,13-18周",
        "add": "电2"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "3-9,13-18周",
        "add": "电2"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "3-9,13-18周",
        "add": "电2"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "3-9,13-18周",
        "add": "电2"
      }
    ],
    {
      "sub": "电力系统分析",
      "tec": "宋泳达",
      "week": "3-9,13-14周",
      "add": "402国教"
    },
    {
      "sub": "数字通讯",
      "tec": "李嘉欣",
      "week": "9,13-18周",
      "add": "教学楼C座114教务"
    }
  ],
  "2": [
    0,
    [
      {
        "sub": "综合英语3",
        "tec": "冯威",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "320国教",
        "tec": "林铁",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "108国教",
        "tec": "张珺莹",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "107国教",
        "tec": "张楹",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "106国教",
        "tec": "刘德娟",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "105国教",
        "tec": "孙琪",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "104国教",
        "tec": "张琳",
        "week": "3-9,13-18周",
        "add": "电8"
      },
      {
        "sub": "101国教",
        "tec": "赵允鹏",
        "week": "3-9,13-18周",
        "add": "电8"
      }
    ],
    {
      "sub": "电机及拖动",
      "tec": "黄硕",
      "week": "3-9,13-18周",
      "add": "213国教"
    },
    {
      "sub": "电力系统分析",
      "tec": "宋泳达",
      "week": "3-9,13-14周",
      "add": "319国教"
    },
    0
  ],
  "3": [
    {
      "sub": "电气测量",
      "tec": "韩希昌",
      "week": "3-9周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "孙新",
      "week": "3-9,13周",
      "add": "教学楼A座119信息"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "模拟电子技术",
      "tec": "张玉梅",
      "week": "3-9,13-18周",
      "add": "319国教"
    },
    {
      "sub": "电机及拖动",
      "tec": "黄硕",
      "week": "3-9,13-18周",
      "add": "213国教"
    },
    [
      {
        "sub": "综合英语3",
        "tec": "赵允鹏",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "103国教",
        "tec": "孙琪",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "104国教",
        "tec": "刘德娟",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "105国教",
        "tec": "张楹",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "106国教",
        "tec": "张珺莹",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "107国教",
        "tec": "林铁",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "108国教",
        "tec": "冯威",
        "week": "3-9,13-18周",
        "add": "电5"
      },
      {
        "sub": "320国教",
        "tec": "张琳",
        "week": "3-9,13-18周",
        "add": "电5"
      }
    ],
    [
      {
        "sub": "就业创业指导",
        "tec": "高子桐",
        "week": "3-7周",
        "add": "教学楼C座112教务"
      },
      {
        "sub": "数字通讯",
        "tec": "李嘉欣",
        "week": "9,13-18周",
        "add": "教学楼C座114教务"
      }
    ],
    0
  ],
  "5": [
    0,
    [
      {
        "sub": "交际口语3",
        "tec": "外教6",
        "week": "3-9,13-18周",
        "add": "电6"
      },
      {
        "sub": "104国教",
        "tec": "外教8",
        "week": "3-9,13-18周",
        "add": "电6"
      },
      {
        "sub": "105国教",
        "tec": "外教9",
        "week": "3-9,13-18周",
        "add": "电6"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "3-9,13-18周",
        "add": "电6"
      }
    ],
    {
      "sub": "电力系统分析",
      "tec": "宋泳达",
      "week": "3-9,13-14周",
      "add": "教学楼C座302教务"
    },
    {
      "sub": "习近平新时代中国特色社会主义思想概论",
      "tec": "孙新",
      "week": "3-9,13周",
      "add": "教学楼A座322电力"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
